export default function now() {
    return (typeof performance === 'undefined' ? Date : performance).now()
}
